import { CalendarCheck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { JANE_APP_URL } from "../data/siteData";
import { trackEvent } from "../lib/analytics";

export const CTABanner = ({
  title = "Ready to help your child thrive?",
  subtitle = "Book an initial evaluation today online or contact us to book. We can't wait to meet your family.",
  service = null,
  onlineBooking = false,
}) => {
  return (
    <section data-testid="cta-banner" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-24">
      <div className="relative overflow-hidden bg-lilac rounded-[2.5rem] px-8 py-14 sm:px-16 text-center">
        <div className="absolute -top-16 -left-16 w-56 h-56 bg-white/40 blob-shape pointer-events-none" />
        <div className="absolute -bottom-20 -right-16 w-64 h-64 bg-butter/60 blob-shape-alt pointer-events-none" />
        <h2 data-testid="cta-banner-title" className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-navy tracking-tight text-balance relative">
          {title}
        </h2>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 relative">
          {onlineBooking ? (
            <a
              href={JANE_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("book_evaluation_click", { location: "cta_banner", service, channel: "jane" })}
              data-testid="cta-book-evaluation-btn"
              className="inline-flex items-center gap-2 bg-sunny text-navy font-extrabold px-8 py-4 rounded-full shadow-lg shadow-black/15 transition-all duration-200 hover:-translate-y-1 hover:bg-sunny-dark focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-lilac"
            >
              <CalendarCheck className="w-5 h-5" strokeWidth={2.5} />
              Book an Evaluation
            </a>
          ) : (
            <Link
              to="/contact"
              onClick={() => trackEvent("book_evaluation_click", { location: "cta_banner", service, channel: "contact" })}
              data-testid="cta-book-evaluation-btn"
              className="inline-flex items-center gap-2 bg-sunny text-navy font-extrabold px-8 py-4 rounded-full shadow-lg shadow-black/15 transition-all duration-200 hover:-translate-y-1 hover:bg-sunny-dark focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-lilac"
            >
              <CalendarCheck className="w-5 h-5" strokeWidth={2.5} />
              Book an Evaluation
            </Link>
          )}
          <Link
            to="/contact"
            data-testid="cta-contact-link"
            className="inline-flex items-center gap-2 text-navy font-bold px-6 py-4 rounded-full border-2 border-navy/30 transition-all duration-200 hover:-translate-y-1 hover:bg-navy hover:text-white"
          >
            Send us a message
            <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </section>
  );
};
